export default function Stall() {
return(
  <svg xmlns="http://www.w3.org/2000/svg" width="176" height="150" viewBox="0 0 176 150" fill="none">
  <rect width="17.7282" height="149.626" fill="#D9D9D9"/>
  <rect x="157.426" width="17.7282" height="149.626" fill="#D9D9D9"/>
  <rect x="8.50879" y="10.6367" width="153.172" height="129.061" fill="#D9D9D9"/>
</svg>
)
}
